import { observer } from 'mobx-react-lite'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import { ProInfoSectionContainer } from '@/features/jobs/details/components/ProInfoSection'
import { ModalResponsesSectionContainer } from '@/features/jobs/details/components/ModalResponsesSection'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { AppointmentSectionContainer } from '@/features/jobs/details/consultation/components/AppointmentSection'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { PersonalInfoSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections/PersonalInfoSectionContainer'
import { BusinessInfoSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections/BusinessInfoSectionContainer'
import { NotesSectionContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections/NotesSectionContainer'
import { SupportSectionContainer } from '@/features/jobs/details/components/SupportSection/SupportSectionContainer'
import { TxfJobSectionContainer } from '@/features/jobs/details/tax-type/txf/components/TxfSectionContainer'

interface TaxJobOverviewTabProps {
  vm: JobDetailsViewModel
  taxVm: TaxJobDetailsViewModel
  displayContactSupport: boolean
}

/**
 * Tax job overview tab.
 */
export const TaxJobOverviewTab = observer(function TaxJobOverviewTab({
  vm,
  taxVm,
  displayContactSupport,
}: TaxJobOverviewTabProps) {
  return (
    <PageLayout
      asideTop={<ProInfoSectionContainer vm={vm} />}
      asideBottom={displayContactSupport && <SupportSectionContainer />}
    >
      <TxfJobSectionContainer
        vm={taxVm.txfJobVm}
        sectionHeadline="Tax information"
      />

      {taxVm.consultationManagerVm.consultation && (
        <AppointmentSectionContainer vm={taxVm.consultationManagerVm} />
      )}
      <PersonalInfoSectionContainer vm={taxVm.infoGatheringVm} />
      <BusinessInfoSectionContainer vm={taxVm.infoGatheringVm} />
      <NotesSectionContainer vm={taxVm.infoGatheringVm.pageVm} />
      <ModalResponsesSectionContainer
        vm={vm.questionsDisplayVm}
        sectionHeadline={
          taxVm.hasTxfIntegration ? 'Your responses' : 'Tax information summary'
        }
        dialogHeadline="View your tax information summary"
      />
    </PageLayout>
  )
})
